import React from 'react';
import theme from './EditProductWizard.module.scss';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { ValidatingInput } from '@/components/forms/validation';
import { BaseProduct, ProfileCatalogProduct } from '@/types';
import InfoIconWithTooltip from '@/seller/components/InfoIconWithTooltip';
import { Select } from '@ygtechnologies/bygr-frontend-component-library';

interface EditProductWizardStepPaintInfoProps {
    product: BaseProduct;
    onChange: (product: BaseProduct | ProfileCatalogProduct) => void;
    allowPriceEdit: boolean;
}

const EditProductWizardStepPaintInfo = ({ product, onChange, allowPriceEdit }: EditProductWizardStepPaintInfoProps) => {
    return (
        <>
            {/* <label>
                <Trans>Title</Trans>
                <MandatoryIndicator />
                <ValidatingInput
                    placeholder={<Trans>Type to add field title - for example ‘NCS colour code’</Trans>}
                    value={product.title}
                    onChange={(e) => onChange({ ...product, title: e.target.value })}
                />
            </label> */}
            {allowPriceEdit && (
                <label>
                    <div className={theme.titleContainer}>
                        <Trans>Catalog price</Trans>
                        <InfoIconWithTooltip
                            content={
                                <Trans>
                                    This price is for your own list price. The price to the buyer is decided when you offer
                                    the product at a later stage. Only people from your organization are able to view your
                                    price in the catalog.
                                </Trans>
                            }
                        />
                    </div>

                    <ValidatingInput
                        autoFocus
                        className="form-control"
                        type="number"
                        value={(product as ProfileCatalogProduct).defaultPrice || ''}
                        onChange={(e) => onChange({ ...product, defaultPrice: +e.target.value })}
                        name="defaultPrice"
                        placeholder={t`Price`}
                    />
                </label>
            )}
            <label>
                <Trans>Colour code</Trans>
                <Select options={[]} isDisabled value={{ label: 'NCS', value: 'NCS' }} />
            </label>
        </>
    );
};

export default EditProductWizardStepPaintInfo;
